import { Component, Inject, OnInit } from '@angular/core';
import { OrderTableComponent } from '../order-table/order-table.component';
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { AmountPipe } from '../../../payments/payment/pipes/amount.pipe';
import { TimestampPipe } from '../../../payments/payment/pipes/timestamp.pipe';

@Component({
  standalone: true,
  imports: [
    MatDialogContent,
    CommonModule,
    OrderTableComponent,
    AmountPipe,
    TimestampPipe
  ],
  selector: 'equine-ui-nx-entry-details-dialog',
  templateUrl: './entry-details-dialog.component.html',
  styleUrls: ['./entry-details-dialog.component.scss']
})
export class EntryDetailsDialogComponent implements OnInit {

  public entry!: any;
  public paid = 0;

  constructor(
    public dialogRef: MatDialogRef<EntryDetailsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  ngOnInit(): void {
    this.entry = this.data;
    if (this.entry && this.entry.orders?.length) {
      this.paid = this.entry.orders[0].paid || 0;
    }
  }

}
